import styled, { css } from 'styled-components'
import { getGridRowWidthValue, themeColor, themeFontFamily, themeFontWeight } from 'LibNeo'

export const GridRowWrapperStyled = styled.div<{ bordered?: boolean }>`
	background-color: ${themeColor('white')};
	border-bottom: 1px solid ${themeColor('gray', 3)};

	${({ bordered }) =>
		bordered &&
		css`
			border: 2px solid ${themeColor('arctic', 6)};
		`}
`

export const GridRowColumnULStyled = styled.ul<{ isActive?: boolean }>`
	width: 100%;
	list-style: none;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 16px 20px;
	margin: 0;
	${({ isActive }) =>
		isActive &&
		css`
			border: 2px solid ${themeColor('arctic', 6)};
		`}
	gap: 8px;
`

export const GridRowColumnLIStyled = styled.li<{ width?: string | number }>`
	${({ width }) => getGridRowWidthValue(width)}

	display: inline-block;
	text-align: left;
	overflow: hidden;
`

export const OpenedComponentWrapper = styled.div`
	border-top: 1px solid ${themeColor('gray', 3)};
	position: relative;
`

export const GridControlExpandWrapperStyled = styled(GridRowColumnLIStyled)<{ absolute?: boolean }>`
	${({ absolute }) =>
		absolute &&
		css`
			position: absolute;
			top: 10px;
			right: 17px;
		`}
`

export const GridCheckWrapperStyled = styled(GridRowColumnLIStyled)<{ absolute?: boolean }>`
	margin-right: 12px;
	${({ absolute }) =>
		absolute &&
		css`
			position: absolute;
			top: 10px;
			left: 17px;
		`}
`

export const GridColText = styled.span`
	color: ${themeColor('extraBackground3')};
	font-family: ${themeFontFamily('SBSansText')};
	font-style: normal;
	font-weight: ${themeFontWeight('SBSansText', 'regular')};
	font-size: 14px;
	line-height: 20px;
`
